// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__LJ+n4","info":"Panel_info__OKfL6","actions":"Panel_actions__JUTc4","button":"Panel_button__figQB"};